// extracted by mini-css-extract-plugin
module.exports = {"container":"_3jGrz","text":"_2ylLA","icon":"_1E2lP"};